// removed by extract-text-webpack-plugin
module.exports = {"auth":"_2OTG3RxE5tFAmVFOalZlnp","container":"wI62vVvf-AIf-G5CBeKM3","header":"E9iZ69Ad2-g3j9Nviii2H","underline":"_2qRi9EuZtfGunaCY1OM9Gi","submit":"_1g6XsXE8HIWnL248JZrl_p"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Auth/auth.module.styl
// module id = 244
// module chunks = 20562568967213 167488991004784